export const namePattern = /^(?=.{1,50}$)[A-Za-zÄÖÜäöüß]+(?:['_.\s][A-Za-zÄÖÜäöüß]+)*$/i;
// eslint-disable-next-line
export const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
// eslint-disable-next-line
export const telPattern = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
export const datePattern = /^\d{2}([./-])\d{2}\1\d{4}$/;
